/**
 * @desc 推送未推送过的mq
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.platDataFlow.amzMqPush.firstPushMqBySize.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/mqPush/firstPushMqBySize`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
